<template>
  <div class="sidebar"
       :data-color="backgroundColor"
       :data-active-color="activeColor">
    <div class="logo">
      <a class="simple-text logo-mini"
         aria-label="sidebar mini logo"
         href="#">
          <div class="logo-img">
              <img :src="logo" alt="">
          </div>
      </a>
      <a class="simple-text logo-normal"
         href="#">
          {{ title }}
      </a>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot>

      </slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in filteredSidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>
    </div>
  </div>
</template>
<script>
  import 'perfect-scrollbar/css/perfect-scrollbar.css'
  import store from "../../../store";
  export default {
    props: {
      title: {
        type: String,
        default: 'VertiHub',
        description: 'Sidebar title'
      },
      backgroundColor: {
        type: String,
        default: 'white',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar background color (white|brown|black)'
      },
      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar active text color (primary|info|success|warning|danger)'
      },
      logo: {
        type: String,
        default: '/static/img/VertiHub-Logo.svg',
        description: 'Sidebar Logo'
      },
      sidebarLinks: {
        type: Array,
        default: () => [],
        description: 'Sidebar links. Can be also provided as children components (sidebar-item)'
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      }
    },
    methods: {
      async initScrollBarAsync () {
        let isWindows = navigator.platform.startsWith('Win');
        if(!isWindows) {
          return;
        }
        const PerfectScroll = await import('perfect-scrollbar')
        // PerfectScroll.initialize(this.$refs.sidebarScrollArea)
      }
    },
    computed: {
      filteredSidebarLinks() {
        if( store.getters.userrole == 0) {
          return this.sidebarLinks.filter(item => item.name == 'Trainer' || item.name == 'Übersicht')
        } else if( store.getters.userrole == 2 || store.getters.userrole == 3 ) {
          return this.sidebarLinks.filter(item => item.name != 'Trainer')
        } else {
          return this.sidebarLinks.filter(item => item.name != 'Parkleitung/Büro' && item.name != 'Trainer')
        }
      }
    },
    mounted () {
      this.initScrollBarAsync()
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style>
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
  .sidebar .logo .simple-text .logo-img img {
    height: 100px !important;
  }
  .sidebar .logo .simple-text, .off-canvas-sidebar .logo .simple-text {
    text-transform: none !important;
  }
  .sidebar .logo .simple-text .logo-img {
    width: 50px !important;
  }
  .sidebar .logo a.logo-mini, .off-canvas-sidebar .logo a.logo-mini {
    width: 50px !important;
  }
</style>
